export default "__VITE_ASSET__d309b755__"